import { ActionType } from '../../models/Action';
import { Condition, ConditionComparison, ValueSource } from '../../models/Condition';
import { Input } from '../../models/Input';
import { ActionViewModel } from '../../models/viewModels/ActionViewModel';
import { ContentActionViewModel } from '../../models/viewModels/ContentActionViewModel';
import { InputViewModel } from '../../models/viewModels/InputViewModel';
import { mapCustomMcpToActions } from '../utils/AgentUtils';
import { CreateAgentStatus } from './Enums';
export const AGENT_FORWARD_TO_AGENT_STATE_STATUS = 'agent_forwardToAgentState_status';
export const contentActionsAiAgent = (textContent) => [
    new ContentActionViewModel({
        input: InputViewModel.create(textContent, new Input({
            bypass: false,
            conditions: [
                new Condition({
                    source: ValueSource.Context,
                    variable: AGENT_FORWARD_TO_AGENT_STATE_STATUS,
                    comparison: ConditionComparison.Equals,
                    values: [CreateAgentStatus.Success],
                }),
            ],
        }), false),
    }),
];
export const enteringAiAgentActions = (settings) => [
    new ActionViewModel({
        type: ActionType.ForwardToAgent,
        conditions: [],
        settings,
    }),
];
export const getAgentConfiguration = (state) => {
    return state.$enteringCustomActions
        .find(action => action.type === ActionType.ForwardToAgent)
        .settings;
};
export const updateAgentConfiguration = (state, configuration) => {
    const action = state.$enteringCustomActions
        .find(action => action.type === ActionType.ForwardToAgent);
    action.settings = configuration;
};
export const mergeLocalActionsWithMcpTools = (state) => {
    state.$localCustomActions = [
        ...state.$localCustomActions.filter(action => action.type !== ActionType.ForwardToAgent),
        ...mapCustomMcpToActions(state),
    ];
};
export const removeToolFromAgentConfiguration = (state, toolKey) => {
    const configuration = getAgentConfiguration(state);
    if (configuration.tools && toolKey in configuration.tools) {
        delete configuration.tools[toolKey];
        updateAgentConfiguration(state, configuration);
        mergeLocalActionsWithMcpTools(state);
    }
};
export const leavingAiAgentActions = [];
export const afterStateChangedAiAgentActions = [
    new ActionViewModel({
        type: ActionType.LeavingFromAgent,
        conditions: [],
        settings: {},
    }),
];
export const localCustomActions = [];
